// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 2000px) {

  .\\!container {
    max-width: 2000px !important;
  }

  .container {
    max-width: 2000px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-9 {
  bottom: 2.25rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[63px\\] {
  top: 63px;
}
.top-\\[78px\\] {
  top: 78px;
}
.isolate {
  isolation: isolate;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-full {
  grid-column: 1 / -1;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.m-0 {
  margin: 0px;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-9 {
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-9 {
  margin-bottom: 2.25rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[2px\\] {
  margin-left: 2px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-row {
  display: table-row;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.contents {
  display: contents;
}
.list-item {
  display: list-item;
}
.hidden {
  display: none;
}
.\\!h-8 {
  height: 2rem !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[4px\\] {
  height: 4px;
}
.h-\\[calc\\(100vh-84px\\)\\] {
  height: calc(100vh - 84px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -webkit-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-max {
  height: -webkit-max-content;
  height: max-content;
}
.h-screen {
  height: 100vh;
}
.max-h-36 {
  max-height: 9rem;
}
.max-h-\\[450px\\] {
  max-height: 450px;
}
.max-h-\\[52vh\\] {
  max-height: 52vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-\\[16rem\\] {
  min-height: 16rem;
}
.min-h-\\[calc\\(100vh-58px\\)\\] {
  min-height: calc(100vh - 58px);
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[23\\.25rem\\] {
  width: 23.25rem;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-fit {
  width: -webkit-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-min {
  width: -webkit-min-content;
  width: min-content;
}
.\\!min-w-max {
  min-width: -webkit-max-content !important;
  min-width: max-content !important;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-\\[500px\\] {
  min-width: 500px;
}
.min-w-\\[600px\\] {
  min-width: 600px;
}
.min-w-\\[70px\\] {
  min-width: 70px;
}
.min-w-\\[84px\\] {
  min-width: 84px;
}
.min-w-\\[95px\\] {
  min-width: 95px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[46\\%\\] {
  max-width: 46%;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[550px\\] {
  max-width: 550px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: -webkit-max-content;
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.\\!cursor-none {
  cursor: none !important;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.scroll-mt-\\[165px\\] {
  scroll-margin-top: 165px;
}
.scroll-mt-\\[175px\\] {
  scroll-margin-top: 175px;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[18px\\] {
  gap: 18px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#E0E0E6\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(224 224 230 / 1);
  border-color: rgb(224 224 230 / var(--tw-divide-opacity, 1));
}
.divide-\\[\\#EAECF0\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(234 236 240 / 1);
  border-color: rgb(234 236 240 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.\\!rounded-md {
  border-radius: 0.375rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.\\!border-\\[2px\\] {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-\\[5px\\] {
  border-width: 5px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#120242\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(18 2 66 / 1) !important;
  border-color: rgb(18 2 66 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#A09DAB\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(160 157 171 / 1) !important;
  border-color: rgb(160 157 171 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#CFCFD9\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(207 207 217 / 1) !important;
  border-color: rgb(207 207 217 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#F59E0B\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / 1) !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#e7e7f1\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(231 231 241 / 1) !important;
  border-color: rgb(231 231 241 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#00B8D9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 184 217 / 1);
  border-color: rgb(0 184 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#00DBAF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 219 175 / 1);
  border-color: rgb(0 219 175 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1A927B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(26 146 123 / 1);
  border-color: rgb(26 146 123 / var(--tw-border-opacity, 1));
}
.border-\\[\\#22C9A0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(34 201 160 / 1);
  border-color: rgb(34 201 160 / var(--tw-border-opacity, 1));
}
.border-\\[\\#5BDEC440\\] {
  border-color: #5BDEC440;
}
.border-\\[\\#AA95E2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(170 149 226 / 1);
  border-color: rgb(170 149 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B42318\\] {
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / 1);
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C4320A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(196 50 10 / 1);
  border-color: rgb(196 50 10 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D0D5DD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / 1);
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D1FADF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 223 / 1);
  border-color: rgb(209 250 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0E0E6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 230 / 1);
  border-color: rgb(224 224 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E7EC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / 1);
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E6E6F2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 230 242 / 1);
  border-color: rgb(230 230 242 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E6E8EC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 232 236 / 1);
  border-color: rgb(230 232 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E7E7F1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(231 231 241 / 1);
  border-color: rgb(231 231 241 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EAECF0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(234 236 240 / 1);
  border-color: rgb(234 236 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F2F4F7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(242 244 247 / 1);
  border-color: rgb(242 244 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FDA29B\\]\\/30 {
  border-color: rgb(253 162 155 / 0.3);
}
.border-\\[\\#FEE4E2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / 1);
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3e3ed\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 227 237 / 1);
  border-color: rgb(227 227 237 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e6e4f0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 228 240 / 1);
  border-color: rgb(230 228 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e7e7f1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(231 231 241 / 1);
  border-color: rgb(231 231 241 / var(--tw-border-opacity, 1));
}
.border-\\[var\\(--color-border-card\\2c \\#E4E7EC\\)\\] {
  border-color: #E4E7EC;
  border-color: var(--color-border-card,#E4E7EC);
}
.border-\\[var\\(--color-border-light\\)\\] {
  border-color: #E4E4E4;
  border-color: var(--color-border-light);
}
.border-\\[var\\(--color-border-light\\2c \\#E0E0E6\\)\\] {
  border-color: #E4E4E4;
  border-color: var(--color-border-light,#E0E0E6);
}
.border-\\[var\\(--color-purple-strong\\)\\] {
  border-color: #3B11B8;
  border-color: var(--color-purple-strong);
}
.border-borderLight {
  border-color: #E4E4E4;
  border-color: var(--color-border-light);
}
.border-themeActive {
  border-color: #E4E4E4;
  border-color: var(--color-border-light);
}
.border-themeBlue {
  border-color: #120242;
  border-color: var(--color-primary);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  border-color: #FFFFFF;
  border-color: var(--color-white);
}
.border-b-\\[\\#E0E0E6\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(224 224 230 / 1);
  border-bottom-color: rgb(224 224 230 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#e7e7f1\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(231 231 241 / 1);
  border-left-color: rgb(231 231 241 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#ef4444\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / 1);
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#0D7A63\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(13 122 99 / 1) !important;
  background-color: rgb(13 122 99 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#101323\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 19 35 / 1) !important;
  background-color: rgb(16 19 35 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#120242\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(18 2 66 / 1) !important;
  background-color: rgb(18 2 66 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#22c9a0\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 201 160 / 1) !important;
  background-color: rgb(34 201 160 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#D1FADF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 250 223 / 1) !important;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#E6F9F7\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 249 247 / 1) !important;
  background-color: rgb(230 249 247 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#ECFDF3\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 253 243 / 1) !important;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#EFF8FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 248 255 / 1) !important;
  background-color: rgb(239 248 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#F2F4F7\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 244 247 / 1) !important;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#F4F3FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 243 255 / 1) !important;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#FEE2E2\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 226 / 1) !important;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#FEE4E2\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 228 226 / 1) !important;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#FEF0C7\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 240 199 / 1) !important;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#FEF3C7\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 243 199 / 1) !important;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0D6F66\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 111 102 / 1);
  background-color: rgb(13 111 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F0A3C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 10 60 / 1);
  background-color: rgb(15 10 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101828\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / 1);
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12B76A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 183 106 / 1);
  background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#14132B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 19 43 / 1);
  background-color: rgb(20 19 43 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A927B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 146 123 / 1);
  background-color: rgb(26 146 123 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22C9A0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 201 160 / 1);
  background-color: rgb(34 201 160 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#98A2B3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(152 162 179 / 1);
  background-color: rgb(152 162 179 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DD588D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(221 88 141 / 1);
  background-color: rgb(221 88 141 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DDFDF6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(221 253 246 / 1);
  background-color: rgb(221 253 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0FFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 255 255 / 1);
  background-color: rgb(224 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E3FAF3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 250 243 / 1);
  background-color: rgb(227 250 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E6E8EC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 232 236 / 1);
  background-color: rgb(230 232 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8D6FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 214 255 / 1);
  background-color: rgb(232 214 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F8F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 248 242 / 1);
  background-color: rgb(232 248 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBEAF2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 234 242 / 1);
  background-color: rgb(235 234 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBFDF9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 253 249 / 1);
  background-color: rgb(235 253 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECEAF5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 234 245 / 1);
  background-color: rgb(236 234 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECFDF3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / 1);
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EEF2F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 246 / 1);
  background-color: rgb(238 242 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F04438\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / 1);
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F2F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 248 / 1);
  background-color: rgb(242 242 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F4F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / 1);
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F0FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 240 254 / 1);
  background-color: rgb(245 240 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / 1);
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F79009\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / 1);
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F1FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 241 255 / 1);
  background-color: rgb(247 241 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F9FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 252 / 1);
  background-color: rgb(248 249 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F9FC\\]\\/40 {
  background-color: rgb(248 249 252 / 0.4);
}
.bg-\\[\\#F9FAFB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / 1);
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAF9FD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 253 / 1);
  background-color: rgb(250 249 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 252 / 1);
  background-color: rgb(250 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCFCFD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 253 / 1);
  background-color: rgb(252 252 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEBB1A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 187 26 / 1);
  background-color: rgb(254 187 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEE4E2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / 1);
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF3F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / 1);
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF5D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 217 / 1);
  background-color: rgb(255 245 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF6ED\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 237 / 1);
  background-color: rgb(255 246 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFAEB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / 1);
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d5d7de\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 222 / 1);
  background-color: rgb(213 215 222 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e3faf3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 250 243 / 1);
  background-color: rgb(227 250 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ebeaf2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 234 242 / 1);
  background-color: rgb(235 234 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eeeef6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 246 / 1);
  background-color: rgb(238 238 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2f2f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 248 / 1);
  background-color: rgb(242 242 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f1ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 241 255 / 1);
  background-color: rgb(247 241 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf9fd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 253 / 1);
  background-color: rgb(250 249 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.5\\)\\] {
  background-color: rgba(255,255,255,0.5);
}
.bg-\\[var\\(--color-bg-card\\2c \\#FFFFFF\\)\\] {
  background-color: #FFFFFF;
  background-color: var(--color-bg-card,#FFFFFF);
}
.bg-\\[var\\(--color-bg-cream\\)\\] {
  background-color: #FEFCFB;
  background-color: var(--color-bg-cream);
}
.bg-\\[var\\(--color-bg-muted-alt\\)\\] {
  background-color: #EFF0F6;
  background-color: var(--color-bg-muted-alt);
}
.bg-\\[var\\(--color-bg-purple-light\\)\\] {
  background-color: #F4F0FF;
  background-color: var(--color-bg-purple-light);
}
.bg-\\[var\\(--color-error-pale\\2c \\#FEF3F2\\)\\] {
  background-color: #FEF3F2;
  background-color: var(--color-error-pale,#FEF3F2);
}
.bg-\\[var\\(--color-secondary\\)\\] {
  background-color: #25D3B1;
  background-color: var(--color-secondary);
}
.bg-\\[var\\(--color-success-bg\\)\\] {
  background-color: #D0F7EF;
  background-color: var(--color-success-bg);
}
.bg-bgPurpleLight {
  background-color: #F4F0FF;
  background-color: var(--color-bg-purple-light);
}
.bg-secondary {
  background-color: #25D3B1;
  background-color: var(--color-secondary);
}
.bg-themeBlue {
  background-color: #120242;
  background-color: var(--color-primary);
}
.bg-themeWhite {
  background-color: #FFFFFF;
  background-color: var(--color-white);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  background-color: #FFFFFF;
  background-color: var(--color-white);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#ECFDF3_0\\%\\2c \\#FFFFFF_100\\%\\)\\] {
  background-image: linear-gradient(180deg,#ECFDF3 0%,#FFFFFF 100%);
}
.bg-\\[linear-gradient\\(180deg\\2c var\\(--color-primary\\)_0\\%\\2c var\\(--color-secondary\\)_170\\%\\)\\] {
  background-image: linear-gradient(180deg,#120242 0%,#25D3B1 170%);
  background-image: linear-gradient(180deg,var(--color-primary) 0%,var(--color-secondary) 170%);
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[var\\(--color-error-red\\2c \\#F04438\\)\\] {
  --tw-gradient-from: var(--color-error-red,#F04438) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[var\\(--color-error-light\\2c \\#F98A8A\\)\\] {
  --tw-gradient-to: var(--color-error-light,#F98A8A) var(--tw-gradient-to-position);
}
.to-\\[var\\(--color-warning-orange2\\2c \\#FD853A\\)\\] {
  --tw-gradient-to: var(--color-warning-orange2,#FD853A) var(--tw-gradient-to-position);
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.object-contain {
  object-fit: contain;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pr-0 {
  padding-right: 0px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.align-middle {
  vertical-align: middle;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-3xl {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[length\\:var\\(--font-size-18\\)\\] {
  font-size: 18px;
  font-size: var(--font-size-18);
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-bold {
  font-weight: 700 !important;
}
.\\!font-medium {
  font-weight: 500 !important;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.\\!normal-case {
  text-transform: none !important;
}
.italic {
  font-style: italic;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[var\\(--line-height-28\\)\\] {
  line-height: 28px;
  line-height: var(--line-height-28);
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.4px\\] {
  letter-spacing: 0.4px;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-\\[\\#027A48\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(2 122 72 / 1) !important;
  color: rgb(2 122 72 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#08251d\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(8 37 29 / 1) !important;
  color: rgb(8 37 29 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#0D6F66\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(13 111 102 / 1) !important;
  color: rgb(13 111 102 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#120242\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(18 2 66 / 1) !important;
  color: rgb(18 2 66 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#175CD3\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(23 92 211 / 1) !important;
  color: rgb(23 92 211 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#1b1b2b\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(27 27 43 / 1) !important;
  color: rgb(27 27 43 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#344054\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / 1) !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#475467\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(71 84 103 / 1) !important;
  color: rgb(71 84 103 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#5D5F6C\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(93 95 108 / 1) !important;
  color: rgb(93 95 108 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#686685\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(104 102 133 / 1) !important;
  color: rgb(104 102 133 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#6941C6\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(105 65 198 / 1) !important;
  color: rgb(105 65 198 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#6b6b81\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(107 107 129 / 1) !important;
  color: rgb(107 107 129 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#B54708\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(181 71 8 / 1) !important;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#D92D20\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(217 45 32 / 1) !important;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#DC2626\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / 1) !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[var\\(--color-text-secondary\\)\\] {
  color: #5D5F6C !important;
  color: var(--color-text-secondary) !important;
}
.\\!text-white {
  color: #FFFFFF !important;
  color: var(--color-white) !important;
}
.text-\\[\\#00B8D9\\] {
  --tw-text-opacity: 1;
  color: rgb(0 184 217 / 1);
  color: rgb(0 184 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#027A48\\] {
  --tw-text-opacity: 1;
  color: rgb(2 122 72 / 1);
  color: rgb(2 122 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#08251D\\] {
  --tw-text-opacity: 1;
  color: rgb(8 37 29 / 1);
  color: rgb(8 37 29 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0D6F66\\] {
  --tw-text-opacity: 1;
  color: rgb(13 111 102 / 1);
  color: rgb(13 111 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0D7A63\\] {
  --tw-text-opacity: 1;
  color: rgb(13 122 99 / 1);
  color: rgb(13 122 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0E9C7C\\] {
  --tw-text-opacity: 1;
  color: rgb(14 156 124 / 1);
  color: rgb(14 156 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0e9c7c\\] {
  --tw-text-opacity: 1;
  color: rgb(14 156 124 / 1);
  color: rgb(14 156 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#101828\\] {
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / 1);
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10B981\\] {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / 1);
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#120242\\] {
  --tw-text-opacity: 1;
  color: rgb(18 2 66 / 1);
  color: rgb(18 2 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#120242\\]\\/60 {
  color: rgb(18 2 66 / 0.6);
}
.text-\\[\\#12B76A\\] {
  --tw-text-opacity: 1;
  color: rgb(18 183 106 / 1);
  color: rgb(18 183 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#130243\\] {
  --tw-text-opacity: 1;
  color: rgb(19 2 67 / 1);
  color: rgb(19 2 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A927B\\] {
  --tw-text-opacity: 1;
  color: rgb(26 146 123 / 1);
  color: rgb(26 146 123 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B1B2B\\] {
  --tw-text-opacity: 1;
  color: rgb(27 27 43 / 1);
  color: rgb(27 27 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D2939\\] {
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / 1);
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1b1b2b\\] {
  --tw-text-opacity: 1;
  color: rgb(27 27 43 / 1);
  color: rgb(27 27 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2B2F36\\] {
  --tw-text-opacity: 1;
  color: rgb(43 47 54 / 1);
  color: rgb(43 47 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#33324a\\] {
  --tw-text-opacity: 1;
  color: rgb(51 50 74 / 1);
  color: rgb(51 50 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344054\\] {
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / 1);
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#373F41\\] {
  --tw-text-opacity: 1;
  color: rgb(55 63 65 / 1);
  color: rgb(55 63 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#392B65\\] {
  --tw-text-opacity: 1;
  color: rgb(57 43 101 / 1);
  color: rgb(57 43 101 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3A394F\\] {
  --tw-text-opacity: 1;
  color: rgb(58 57 79 / 1);
  color: rgb(58 57 79 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3b11b8\\] {
  --tw-text-opacity: 1;
  color: rgb(59 17 184 / 1);
  color: rgb(59 17 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#414651\\] {
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / 1);
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#475467\\] {
  --tw-text-opacity: 1;
  color: rgb(71 84 103 / 1);
  color: rgb(71 84 103 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4F46E5\\] {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / 1);
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5D5F6C\\] {
  --tw-text-opacity: 1;
  color: rgb(93 95 108 / 1);
  color: rgb(93 95 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5d5f6c\\] {
  --tw-text-opacity: 1;
  color: rgb(93 95 108 / 1);
  color: rgb(93 95 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667085\\] {
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / 1);
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#686685\\] {
  --tw-text-opacity: 1;
  color: rgb(104 102 133 / 1);
  color: rgb(104 102 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#68677c\\] {
  --tw-text-opacity: 1;
  color: rgb(104 103 124 / 1);
  color: rgb(104 103 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6941C6\\] {
  --tw-text-opacity: 1;
  color: rgb(105 65 198 / 1);
  color: rgb(105 65 198 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B6B81\\] {
  --tw-text-opacity: 1;
  color: rgb(107 107 129 / 1);
  color: rgb(107 107 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b6b81\\] {
  --tw-text-opacity: 1;
  color: rgb(107 107 129 / 1);
  color: rgb(107 107 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#717188\\] {
  --tw-text-opacity: 1;
  color: rgb(113 113 136 / 1);
  color: rgb(113 113 136 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A6400\\] {
  --tw-text-opacity: 1;
  color: rgb(138 100 0 / 1);
  color: rgb(138 100 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8E8EA9\\] {
  --tw-text-opacity: 1;
  color: rgb(142 142 169 / 1);
  color: rgb(142 142 169 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9797AB\\] {
  --tw-text-opacity: 1;
  color: rgb(151 151 171 / 1);
  color: rgb(151 151 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9797ab\\] {
  --tw-text-opacity: 1;
  color: rgb(151 151 171 / 1);
  color: rgb(151 151 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#98A2B3\\] {
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / 1);
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A09DAB\\] {
  --tw-text-opacity: 1;
  color: rgb(160 157 171 / 1);
  color: rgb(160 157 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B42318\\] {
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / 1);
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B54708\\] {
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / 1);
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C4320A\\] {
  --tw-text-opacity: 1;
  color: rgb(196 50 10 / 1);
  color: rgb(196 50 10 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D32F2F\\] {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / 1);
  color: rgb(211 47 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D92D20\\] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / 1);
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D97706\\] {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / 1);
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF4444\\] {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / 1);
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F04438\\] {
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / 1);
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F97316\\] {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / 1);
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-\\[color\\:var\\(--color-text-muted\\)\\] {
  color: #2B2F36;
  color: var(--color-text-muted);
}
.text-\\[color\\:var\\(--color-text-secondary\\)\\] {
  color: #5D5F6C;
  color: var(--color-text-secondary);
}
.text-\\[var\\(--color-border-muted\\)\\] {
  color: #CFCFD9;
  color: var(--color-border-muted);
}
.text-\\[var\\(--color-primary\\)\\] {
  color: #120242;
  color: var(--color-primary);
}
.text-\\[var\\(--color-purple-deep-alt\\)\\] {
  color: #23008A;
  color: var(--color-purple-deep-alt);
}
.text-\\[var\\(--color-purple-strong\\)\\] {
  color: #3B11B8;
  color: var(--color-purple-strong);
}
.text-\\[var\\(--color-success-dark\\)\\] {
  color: #1A927B;
  color: var(--color-success-dark);
}
.text-\\[var\\(--color-text-mid\\)\\] {
  color: #475467;
  color: var(--color-text-mid);
}
.text-\\[var\\(--color-text-muted\\)\\] {
  color: #2B2F36;
  color: var(--color-text-muted);
}
.text-\\[var\\(--color-text-primary\\2c \\#120242\\)\\] {
  color: #120242;
  color: var(--color-text-primary,#120242);
}
.text-\\[var\\(--color-text-purple\\)\\] {
  color: #686685;
  color: var(--color-text-purple);
}
.text-\\[var\\(--color-text-secondary\\)\\] {
  color: #5D5F6C;
  color: var(--color-text-secondary);
}
.text-\\[var\\(--color-text-secondary\\2c \\#5D5F6C\\)\\] {
  color: #5D5F6C;
  color: var(--color-text-secondary,#5D5F6C);
}
.text-black {
  color: #000000;
  color: var(--color-black);
}
.text-primary {
  color: #120242;
  color: var(--color-primary);
}
.text-secondary {
  color: #25D3B1;
  color: var(--color-secondary);
}
.text-themeBlue {
  color: #120242;
  color: var(--color-primary);
}
.text-themeWhite {
  color: #FFFFFF;
  color: var(--color-white);
}
.text-transparent {
  color: transparent;
}
.text-white {
  color: #FFFFFF;
  color: var(--color-white);
}
.underline {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.overline {
  -webkit-text-decoration-line: overline;
          text-decoration-line: overline;
}
.line-through {
  -webkit-text-decoration-line: line-through;
          text-decoration-line: line-through;
}
.no-underline {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-\\[\\#98A2B3\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(152 162 179 / 1);
  color: rgb(152 162 179 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-90 {
  opacity: 0.9;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 10px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_12px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 6px 12px 2px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 6px 12px 2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_10px_30px_-5px_rgba\\(18\\2c 2\\2c 66\\2c 0\\.06\\)\\] {
  --tw-shadow: 0px 10px 30px -5px rgba(18,2,66,0.06);
  --tw-shadow-colored: 0px 10px 30px -5px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_1px_8px_0px_var\\(--color-shadow-card\\)\\] {
  --tw-shadow: 0px 1px 8px 0px var(--color-shadow-card);
  --tw-shadow-colored: 0px 1px 8px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_20px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0px 4px 20px 0px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0px 4px 20px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_4px_0px_\\#0000000D\\] {
  --tw-shadow: 0px 4px 4px 0px #0000000D;
  --tw-shadow-colored: 0px 4px 4px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#F59E0B\\]\\/50 {
  --tw-ring-color: rgb(245 158 11 / 0.5);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[1\\.5px\\] {
  --tw-backdrop-blur: blur(1.5px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* ============================================================
   DESIGN TOKENS — CSS Custom Properties
   Single source of truth for all colors in the app.
   Use these variables instead of hardcoded hex/rgba values.
   ============================================================ */
:root {
  /* === BRAND === */
  --color-primary: #120242;
  --color-secondary: #25D3B1;
  --color-secondary-dark: #1FB89C;
  --color-primary-bright: #5569ff;

  /* === TEXT === */
  --color-text-primary: #120242;
  --color-text-secondary: #5D5F6C;
  --color-text-tertiary: #667085;
  --color-text-placeholder: #98A2B3;
  --color-text-input: #1F252A;
  --color-text-dark: #344054;
  --color-text-darkest: #101828;
  --color-text-mid: #475467;
  --color-text-purple: #686685;
  --color-text-muted-purple: #A09DAB;
  --color-text-muted: #2B2F36;
  --color-text-heading: #11142D;
  --color-text-near-black: #13191E;
  --color-text-sidebar-icon: #414247;
  --color-text-dark-grey: #474747;
  --color-text-navy: #293241;
  --color-text-dark2: #1D2939;
  --color-text-near-black2: #1F1F1F;
  --color-text-grey-purple: #808191;
  --color-text-medium-grey: #555555;
  --color-text-grey2: #666666;
  --color-text-grey3: #888888;
  --color-text-light-grey: #999999;
  --color-text-dark3: #333333;

  /* === SEMANTIC: SUCCESS === */
  --color-success: #57CA22;
  --color-success-alt: #18B74A;
  --color-success-bright: #00C48C;
  --color-success-medium: #33DBBA;
  --color-success-dark: #1A927B;
  --color-success-darker: #167E6A;
  --color-success-darkest: #0E5245;
  --color-success-very-dark: #072721;
  --color-success-green: #166534;
  --color-success-bg: #D0F7EF;
  --color-success-bg-lightest: #D1F5EE;
  --color-success-bg-ultra: rgba(235, 255, 250, 1);
  --color-success-border: #87DCB8;

  /* === SEMANTIC: WARNING === */
  --color-warning: #FFA319;
  --color-warning-alt: #F4A952;
  --color-warning-dark: #ED9D1D;
  --color-warning-orange: #F79009;
  --color-warning-light: #FDCC77;
  --color-warning-yellow: #F6E314;
  --color-warning-bright: #FFD600;
  --color-warning-yellow-green: #BEDA1E;

  /* === SEMANTIC: ERROR === */
  --color-error: #FF1943;
  --color-error-alt: #F45252;
  --color-error-red: #F04438;
  --color-error-bright: #F94144;
  --color-error-light: #F98A8A;
  --color-error-dark: #D92D20;
  --color-error-orange: #E64420;
  --color-error-darker: #D32F2F;
  --color-error-darkest: #B42318;
  --color-error-bg: #FEE4E2;

  /* === SEMANTIC: INFO === */
  --color-info: #33C2FF;
  --color-info-blue: #0288D1;

  /* === BACKGROUNDS === */
  --color-bg-page: #F7F7F7;
  --color-bg-card: #FFFFFF;
  --color-bg-cream: #FEFCFB;
  --color-bg-light-purple: #F6F3FF;
  --color-bg-purple-tint: #F7F4FC;
  --color-bg-subtle: #F9FAFB;
  --color-bg-muted: #F2F4F7;
  --color-bg-muted-alt: #EFF0F6;
  --color-bg-purple-light: #F4F0FF;
  --color-bg-purple-light2: #E7DFFF;
  --color-bg-grey: #F5F5F5;
  --color-bg-grey2: #F3F3F3;
  --color-bg-grey3: #F1F1F1;
  --color-bg-very-light: #F8F8FA;
  --color-bg-purple-subtle: #F5F7FF;
  --color-bg-mid-grey: #EEEEEE;
  --color-bg-border-grey: #E5E7EB;

  /* === BORDERS === */
  --color-border: #D0D5DD;
  --color-border-light: #E4E4E4;
  --color-border-medium: #EAECF0;
  --color-border-card: #E4E7EC;
  --color-border-muted: #CFCFD9;
  --color-border-grey: #E0E0E0;
  --color-border-light2: #CCCCCC;

  /* === NEUTRAL === */
  --color-white: #FFFFFF;
  --color-black: #000000;
  --color-near-black-grey: #202124;

  /* === PURPLE PALETTE === */
  --color-purple-strong: #3B11B8;
  --color-purple-deep: #0D0131;
  --color-purple-mid: #392B65;
  --color-purple-dark: #15024E;
  --color-purple-deep-alt: #23008A;

  /* === FEATURE-SPECIFIC COLORS === */
  --color-success-alt2: #12B76A;
  --color-success-green2: #0CAF60;
  --color-success-deep: #027A48;
  --color-success-medium2: #059669;
  --color-teal: #20B2AA;
  --color-highlight: #0B6BCB;
  --color-purple-alt: #5134A9;
  --color-purple-ultra-dark: #0D012E;
  --color-near-white: #FCFCFD;
  --color-bg-off-white: #F9F9F9;
  --color-bg-light-neutral: #EAEAEA;
  --color-bg-success-light: #E3FFE0;
  --color-border-neutral: #D1D5DB;
  --color-text-grey4: #9E9E9E;
  --color-text-grey5: #6B7280;
  --color-warning-pale: #FEF0C7;
  --color-error-pale: #FEF3F2;
  --color-warning-peach: #FFEAD5;
  --color-warning-orange2: #FD853A;
  --color-warning-orange3: #FB6514;
  --color-warning-amber: #F59E0B;
  --color-error-near: #F45251;
  --color-bg-fog: #F2F5F9;
  --color-bg-mint: #F0FDF4;
  --color-bg-lavender: #EEF0F8;
  --color-bg-slate: #E6E8F0;
  --color-error-muted: #DF4B4B;
  --color-border-faint: #DCDCDC;
  --color-border-faint2: #D2D2D2;
  --color-error-burnt: #D33F25;
  --color-success-pastel: #A6E3B8;
  --color-warning-brown: #92400E;
  --color-text-grey6: #808080;
  --color-text-grey7: #767676;
  --color-purple-vivid: #663FDA;
  --color-purple-vivid2: #6544C8;
  --color-teal-bright: #47E9C9;
  --color-google-blue: #4285F4;
  --color-purple-rich: #3510A3;
  --color-shadow-xs: rgba(52, 53, 83, 0.12);
  --color-secondary-darker: #1FB496;
  --color-google-link: #1A0DAB;
  --color-success-deep2: #198639;
  --color-primary-ultra: #0F0238;

  /* === ANIMATION COLORS === */
  --color-pulse-orange: #ff7f0e;
  --color-pulse-blue: #cfebff;

  /* === MISC UI COLORS === */
  --color-text-dark-slate: #47525D;
  --color-overlay-grey: rgba(128, 128, 128, 0.78);
  --color-info-shorthand: #1199FF;
  --color-bg-silver: #E9E9E9;
  --color-success-material: #4CAF50;
  --color-accent-violet: #CD7FE8;
  --color-text-charcoal: #404040;

  /* === SHADOWS === */
  --color-shadow-card: rgba(52, 52, 83, 0.14);
  --color-shadow-sm: rgba(16, 24, 40, 0.05);


  /* === FONTS === */
  --font-size-12: 12px;
  --font-size-14: 14px;
  --font-size-15: 15px;
  --font-size-16: 16px;
  --font-size-18: 18px;
  --font-size-20: 20px;
  --font-size-24: 24px;
  --font-size-28: 28px;
  --font-size-30: 30px;
  --font-size-32: 32px;
  --font-size-36: 36px;

  --line-height-14: 14px;
  --line-height-16: 16px;
  --line-height-18: 18px;
  --line-height-20: 20px;
  --line-height-22: 22px;
  --line-height-24: 24px;
  --line-height-28: 28px;
  --line-height-30: 30px;
  --line-height-32: 32px;
  --line-height-36: 36px;
  --line-height-38: 38px;
  --line-height-44: 44px;

}

html,
body {
  height: 100%;
  font-family: 'Inter', sans-serif !important;
  background-color: #F7F7F7;
  background-color: var(--color-bg-page);
  overflow-x: hidden;
}

#root {
  height: 100%;
}

.url-log {
  width: 35px;
  height: 35px;
  object-fit: scale-down;
}

.site-box .box-title {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* font-family: 'RalewayThin'; */
  font-weight: 600;
  font-size: 14px;
  color: #808191;
  color: var(--color-text-grey-purple);
}

.header-log-box {
  position: fixed;
  background: #FFFFFF;
  background: var(--color-bg-card);
  height: 63px;
  border-bottom: 2px solid rgba(244, 244, 244, 1);
  width: 250px;
  margin-top: -10px;
  z-index: 10000;
  padding: 15px 20px 15px 25px;
  display: flex;
  align-items: end;
}

.table-box-title {
  color: #11142D;
  color: var(--color-text-heading);
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin-left: 15px;
  max-width: 30rem;
}

td {
  vertical-align: middle !important;
  padding: 5px 5px 5px 15px !important;
}

td .MuiCircularProgress-root {
  margin-top: 5px;
}

table#pdfExport,
th,
td {
  border-bottom: 1px solid lightgray;
  border-collapse: collapse;
}

table#pdfExport th,
td {
  padding: 5px;
  text-align: left;
}

#pdfExport td {
  vertical-align: middle !important;
  padding: 15px 5px 15px 5px !important;
}

#pdfExport td .MuiCircularProgress-root {
  margin-top: 5px;
}

.login-image-bg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}

.register-img-top {
  top: -11px;
  left: -3px;
  width: 195px;
  transform: rotate(-179.78deg);
  transform: rotate(-360.78deg);
}

.signup-form .MuiButton-outlinedPrimary {
  font-size: 14px !important;
  font-weight: 700 !important;
  font-style: normal !important;
  letter-spacing: 0.3px !important;
  border-radius: 4px !important;
  border: 3px solid #120242 !important;
  border: 3px solid var(--color-primary) !important;
  text-transform: inherit !important;
  color: #120242 !important;
  color: var(--color-primary) !important;
  height: 49px;
}

.signup-form .MuiButton-outlinedPrimary:hover {
  font-size: 14px !important;
  font-weight: 700 !important;
  font-style: normal !important;
  letter-spacing: 0.3px !important;
  border-radius: 4px !important;
  border: 3px solid #120242 !important;
  border: 3px solid var(--color-primary) !important;
  text-transform: inherit !important;
  background: #120242 !important;
  background: var(--color-primary) !important;
  color: #FFFFFF !important;
  color: var(--color-white) !important;
  height: 49px;
}

.result-section .MuiCardActions-root .MuiPaper-root {
  background: #FFFFFF;
  background: var(--color-bg-card);
}

.font-manrope {
  font-family: 'Manrope';
}

.font-raleway {
  font-family: 'Inter', sans-serif;
}

.font-poppins {
  font-family: 'Poppins';
}

.font-inter {
  font-family: 'Inter', sans-serif;
}

.get-more-scan {
  font-family: 'Inter', sans-serif !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 12px !important;
  text-align: right !important;
  letter-spacing: 0.2px !important;
  -webkit-text-decoration-line: underline !important;
          text-decoration-line: underline !important;
  color: #3B11B8 !important;
  color: var(--color-purple-strong) !important;
}

.date-format-css {
  /* font-family: 'Inter'; */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #11142D;
  color: var(--color-text-heading);
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.form-title {
  font-weight: 400 !important;
  font-size: '18px' !important;
  /* font-family: 'Poppins' !important; */
  color: #11142D !important;
  color: var(--color-text-heading) !important;
  margin-bottom: '16px' !important;
}

button.MuiButton-containedError {
  box-shadow: none !important;
}

.scan-modal .common-text,
.common-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0px;
  /* font-family: 'Inter'; */
  color: rgb(0, 0, 0);
}

.watch_tutorial {
  color: #8c6af2;
  text-decoration: none;
  font-weight: 600;
}

.scroll-block {
  padding: 5px;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
}

.scroll-block::-webkit-scrollbar-thumb {
  background-color: rgb(160, 170, 180);
  border: 3px solid rgb(160, 170, 180);
  border-radius: 20px;
}

.scroll-block::-webkit-scrollbar {
  width: 3px;
}

.hire-us {
  /* text-align: -webkit-center;
  display: flex;
  padding-top: 15px;
  padding-bottom: 5px;
  padding-left: 19px */
}

.MuiInputBase-input {
  background: transparent !important;
}

.scan-button .view-scan-button:hover {
  background-color: transparent;
  border: 0px;
}

.k-pdf-viewer> :nth-child(3) {
  background-image: none !important;
  background-image: initial !important;
  position: static !important;
  position: initial !important;
}

.new-added-buy-slot input {
  padding: 5px 5px 5px 10px;
}

.new-added-buy-slot .top-bottom {
  height: auto;
}

.new-added-buy-slot button {
  padding: 5px 5px 5px 5px;
}

.active-toggle .text-label {
  transition: all 0.3s 0.1s ease-in-out;
}

.watch_tutorial_link {
  font-weight: 700;
  letter-spacing: 0.2px;
  margin: 0px;
  font-size: 13px;
  /* font-family: Poppins; */
  color: #120242;
  color: var(--color-primary);
}

/* styles.css */
@keyframes pulseBorder {
  0% {
    border-color: #ff7f0e;
    border-color: var(--color-pulse-orange);
    box-shadow: 0 0 20px rgba(255, 127, 14, 0.7);
  }

  50% {
    border-color: #cfebff;
    border-color: var(--color-pulse-blue);
    box-shadow: 0 0 20px rgba(0, 0, 255, 0.7);
  }

  100% {
    border-color: #ff7f0e;
    border-color: var(--color-pulse-orange);
    box-shadow: 0 0 20px rgba(255, 127, 14, 0.7);
  }
}

.chrome-extension-card {
  position: relative;
  background-color: #cfebff;
  background-color: var(--color-pulse-blue);
  border: 2px solid;
  border-color: #ff7f0e;
  border-color: var(--color-pulse-orange);
  animation: pulseBorder 2s infinite;
  border-radius: 10px;
}

.chrome-extension-card::after {
  content: '';
  position: absolute;
  top: -15px;
  left: -15px;
  right: -15px;
  bottom: -15px;
  background-color: rgba(255, 127, 14, 0.7);
  opacity: 0.5;
  z-index: -1;
  border-radius: 15px;
}

iframe.seo-space-iframe #root {
  overflow: hidden;
}
.chrome-modal-secondory-text {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  color: #120242;
  color: var(--color-primary);
}

/* Custom Sleek Thin Scrollbar */
.scrollbar-thin::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #D0D5DD;
  background: var(--color-border, #D0D5DD);
  border-radius: 4px;
}

.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: #D0D5DD transparent;
  scrollbar-color: var(--color-border, #D0D5DD) transparent;
}

/* Animated Gradient Border using CSS @property (Cruip pattern) */
@property --border-angle {
  inherits: false;
  initial-value: 0deg;
  syntax: '<angle>';
}

@keyframes orbit-border-rotate {
  to {
    --border-angle: 360deg;
  }
}

.orbit-animated-gradient-border {
  border: 1.5px solid transparent;
  border-radius: 10px;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    conic-gradient(
      from var(--border-angle),
      #E4E4E4 80%,
      #1FB89C 86%,
      #5569ff 90%,
      #DD588D 94%,
      #E4E4E4
    ) border-box;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    conic-gradient(
      from var(--border-angle),
      var(--color-border-light, #E0E0E6) 80%,
      #1FB89C 86%,
      var(--color-primary-bright, #5569ff) 90%,
      #DD588D 94%,
      var(--color-border-light, #E0E0E6)
    ) border-box;
  animation: orbit-border-rotate 4s linear infinite;
}

/* Backward-compatibility alias */
.orbit-rotating-card-wrapper {
  border: 1.5px solid transparent;
  border-radius: 10px;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    conic-gradient(
      from var(--border-angle),
      #E4E4E4 80%,
      #1FB89C 86%,
      #5569ff 90%,
      #DD588D 94%,
      #E4E4E4
    ) border-box;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    conic-gradient(
      from var(--border-angle),
      var(--color-border-light, #E0E0E6) 80%,
      #1FB89C 86%,
      var(--color-primary-bright, #5569ff) 90%,
      #DD588D 94%,
      var(--color-border-light, #E0E0E6)
    ) border-box;
  animation: orbit-border-rotate 4s linear infinite;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:top-full::after {
  content: var(--tw-content);
  top: 100%;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:border-4::after {
  content: var(--tw-content);
  border-width: 4px;
}
.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.after\\:border-t-themeBlue::after {
  content: var(--tw-content);
  border-top-color: #120242;
  border-top-color: var(--color-primary);
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.first\\:border-l-0:first-child {
  border-left-width: 0px;
}
.first\\:pl-0:first-child {
  padding-left: 0px;
}
.first\\:pt-4:first-child {
  padding-top: 1rem;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:rounded-lg:hover {
  border-radius: 0.5rem;
}
.hover\\:border-\\[\\#0D6F66\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(13 111 102 / 1);
  border-color: rgb(13 111 102 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#1A927B\\]\\/40:hover {
  border-color: rgb(26 146 123 / 0.4);
}
.hover\\:border-\\[\\#B42318\\]\\/40:hover {
  border-color: rgb(180 35 24 / 0.4);
}
.hover\\:border-\\[\\#C4320A\\]\\/40:hover {
  border-color: rgb(196 50 10 / 0.4);
}
.hover\\:border-\\[\\#D0D5DD\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / 1);
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1));
}
.hover\\:\\!bg-\\[\\#1E243B\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 36 59 / 1) !important;
  background-color: rgb(30 36 59 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:\\!bg-\\[\\#1c0a52\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(28 10 82 / 1) !important;
  background-color: rgb(28 10 82 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:\\!bg-\\[\\#FCA5A5\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(252 165 165 / 1) !important;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:bg-\\[\\#1BB690\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 182 144 / 1);
  background-color: rgb(27 182 144 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#201861\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(32 24 97 / 1);
  background-color: rgb(32 24 97 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F9FAFB\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / 1);
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FEE4E2\\]\\/50:hover {
  background-color: rgb(254 228 226 / 0.5);
}
.hover\\:bg-\\[var\\(--color-bg-purple-tint\\)\\]:hover {
  background-color: #F7F4FC;
  background-color: var(--color-bg-purple-tint);
}
.hover\\:bg-themeBlue:hover {
  background-color: #120242;
  background-color: var(--color-primary);
}
.hover\\:text-\\[\\#094d47\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(9 77 71 / 1);
  color: rgb(9 77 71 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#0B7A61\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(11 122 97 / 1);
  color: rgb(11 122 97 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#0D6F66\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(13 111 102 / 1);
  color: rgb(13 111 102 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#0b7a61\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(11 122 97 / 1);
  color: rgb(11 122 97 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#101828\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / 1);
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1D2939\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / 1);
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#4F46E5\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / 1);
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  color: #FFFFFF;
  color: var(--color-white);
}
.hover\\:underline:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-\\[\\#0F0A3C\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(15 10 60 / 1);
  border-color: rgb(15 10 60 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[var\\(--color-text-purple\\)\\]:focus {
  border-color: #686685;
  border-color: var(--color-text-purple);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[var\\(--color-text-purple\\)\\]:focus {
  --tw-ring-color: var(--color-text-purple);
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:hover\\:bg-white:hover:disabled {
  background-color: #FFFFFF;
  background-color: var(--color-white);
}
.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:underline {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
@media (min-width: 640px) {

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:self-center {
    align-self: center;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:top-\\[80px\\] {
    top: 80px;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:m-0 {
    margin: 0px;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:h-\\[40px\\] {
    height: 40px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:min-h-\\[40px\\] {
    min-height: 40px;
  }

  .md\\:w-\\[275px\\] {
    width: 275px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-none {
    max-width: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[0\\.5fr_2fr_1fr\\] {
    grid-template-columns: 0.5fr 2fr 1fr;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:self-auto {
    align-self: auto;
  }

  .md\\:border-l {
    border-left-width: 1px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:p-\\[1rem\\] {
    padding: 1rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:pl-6 {
    padding-left: 1.5rem;
  }

  .md\\:pr-6 {
    padding-right: 1.5rem;
  }

  .md\\:pt-16 {
    padding-top: 4rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .md\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:order-3 {
    order: 3;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:mr-4 {
    margin-right: 1rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:w-\\[350px\\] {
    width: 350px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-fit {
    width: -webkit-fit-content;
    width: fit-content;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:max-w-sm {
    max-width: 24rem;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[3fr_4fr\\] {
    grid-template-columns: 3fr 4fr;
  }

  .lg\\:grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .lg\\:gap-5 {
    gap: 1.25rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:border-\\[\\#EAECF0\\] {
    --tw-border-opacity: 1;
    border-color: rgb(234 236 240 / 1);
    border-color: rgb(234 236 240 / var(--tw-border-opacity, 1));
  }

  .lg\\:p-3 {
    padding: 0.75rem;
  }

  .lg\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .lg\\:pl-0 {
    padding-left: 0px;
  }

  .lg\\:pr-8 {
    padding-right: 2rem;
  }

  .lg\\:pt-4 {
    padding-top: 1rem;
  }

  .lg\\:pt-5 {
    padding-top: 1.25rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 1280px) {

  .xl\\:p-5 {
    padding: 1.25rem;
  }

  .xl\\:text-\\[40px\\] {
    font-size: 40px;
  }
}
@media (min-width: 2000px) {

  .\\32xl\\:w-96 {
    width: 24rem;
  }
}
.\\[\\&_b\\]\\:font-semibold b {
  font-weight: 600;
}
.\\[\\&_b\\]\\:text-\\[\\#1D2939\\] b {
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / 1);
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.\\[\\&_strong\\]\\:font-semibold strong {
  font-weight: 600;
}
.\\[\\&_strong\\]\\:text-\\[\\#1D2939\\] strong {
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / 1);
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;UAAnB;AAAmB;AAAnB;EAAA,sCAAmB;UAAnB;AAAmB;AAAnB;EAAA,0CAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,oDAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,0DAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,8DAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,2DAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,4DAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,wKAAmB;EAAnB,wJAAmB;EAAnB,gNAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,+FAAmB;EAAnB,8HAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;;iEAIiE;AACjE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;;EAE3B,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;EACpC,gDAAgD;EAChD,+BAA+B;;EAE/B,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;;EAErC,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;;EAEzB,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;;EAE1B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,+BAA+B;;EAE/B,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;;EAE9B,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;;EAEhC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;;EAEhC,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,yCAAyC;EACzC,iCAAiC;EACjC,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;;EAE9B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;;EAE3B,2BAA2B;EAC3B,gCAAgC;EAChC,+CAA+C;EAC/C,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,8BAA8B;;EAE9B,oBAAoB;EACpB,2CAA2C;EAC3C,yCAAyC;;;EAGzC,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;AAExB;;AAEA;;EAEE,YAAY;EACZ,2CAA2C;EAC3C,yBAAsC;EAAtC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mBAAgC;EAAhC,gCAAgC;EAChC,YAAY;EACZ,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAgC;EAAhC,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAiD;EAAjD,iDAAiD;EACjD,kCAAgC;EAChC,yBAAsC;EAAtC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAiD;EAAjD,iDAAiD;EACjD,kCAAgC;EAChC,8BAA2C;EAA3C,2CAA2C;EAC3C,yBAAoC;EAApC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,mBAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,kDAA0C;UAA1C,0CAA0C;EAC1C,yBAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAgC;EAAhC,gCAAgC;EAChC,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,uCAAuC;EACvC,yBAA2C;EAA3C,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EAEd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;;;sBAIoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,iCAAkC;EAAlC,oCAAkC;EAClC,2BAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAIE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,cAA2B;EAA3B,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,qBAAuC;IAAvC,uCAAuC;IACvC,4CAA4C;EAC9C;;EAEA;IACE,qBAAqC;IAArC,qCAAqC;IACrC,yCAAyC;EAC3C;;EAEA;IACE,qBAAuC;IAAvC,uCAAuC;IACvC,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyC;EAAzC,yCAAyC;EACzC,iBAAiB;EACjB,qBAAuC;EAAvC,uCAAuC;EACvC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAA2B;EAA3B,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAwC;EAAxC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAyD;EAAzD,yDAAyD;AAC3D;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB;;;;;;;;;gBASc;EATd;;;;;;;;;gBASc;EACd,iDAAiD;AACnD;;AAEA,iCAAiC;AACjC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB;;;;;;;;;gBASc;EATd;;;;;;;;;gBASc;EACd,iDAAiD;AACnD;AAvlBA;EAAA,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF,sBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,0BAulBE;EAvlBF,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,gBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,sBAulBE;EAvlBF,iCAulBE;EAvlBF;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,sBAulBE;EAvlBF,kCAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,6BAulBE;EAvlBF,8CAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,6BAulBE;EAvlBF,8CAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,6BAulBE;EAvlBF,iDAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,kBAulBE;EAvlBF,qCAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,kBAulBE;EAvlBF,mCAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,kBAulBE;EAvlBF,sCAulBE;EAvlBF;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,uBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,0BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,wBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,wBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,cAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,uCAulBE;UAvlBF;AAulBE;AAvlBF;EAAA,0CAulBE;EAvlBF,uDAulBE;EAvlBF,kDAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,sBAulBE;EAvlBF,+BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,qBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,8BAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,2GAulBE;EAvlBF,yGAulBE;EAvlBF,0EAulBE;EAvlBF;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,yBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA,uCAulBE;UAvlBF;AAulBE;AAvlBF;;EAAA;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,oBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,eAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,mBAulBE;IAvlBF;EAulBE;AAAA;AAvlBF;;EAAA;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,gBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,gBAulBE;IAvlBF,oBAulBE;IAvlBF,4BAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,iBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,kBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,oBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,iBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,mBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,eAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,mBAulBE;IAvlBF;EAulBE;AAAA;AAvlBF;;EAAA;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,gBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,0BAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,sBAulBE;IAvlBF,kCAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;;EAvlBF;IAAA,kBAulBE;IAvlBF;EAulBE;;EAvlBF;IAAA,+EAulBE;IAvlBF,mGAulBE;IAvlBF,kDAulBE;IAvlBF;EAulBE;AAAA;AAvlBF;;EAAA;IAAA;EAulBE;;EAvlBF;IAAA;EAulBE;AAAA;AAvlBF;;EAAA;IAAA;EAulBE;AAAA;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,wBAulBE;EAvlBF;AAulBE;AAvlBF;EAAA;AAulBE;AAvlBF;EAAA,oBAulBE;EAvlBF,wBAulBE;EAvlBF;AAulBE","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n/* ============================================================\r\n   DESIGN TOKENS — CSS Custom Properties\r\n   Single source of truth for all colors in the app.\r\n   Use these variables instead of hardcoded hex/rgba values.\r\n   ============================================================ */\r\n:root {\r\n  /* === BRAND === */\r\n  --color-primary: #120242;\r\n  --color-secondary: #25D3B1;\r\n  --color-secondary-dark: #1FB89C;\r\n  --color-primary-bright: #5569ff;\r\n\r\n  /* === TEXT === */\r\n  --color-text-primary: #120242;\r\n  --color-text-secondary: #5D5F6C;\r\n  --color-text-tertiary: #667085;\r\n  --color-text-placeholder: #98A2B3;\r\n  --color-text-input: #1F252A;\r\n  --color-text-dark: #344054;\r\n  --color-text-darkest: #101828;\r\n  --color-text-mid: #475467;\r\n  --color-text-purple: #686685;\r\n  --color-text-muted-purple: #A09DAB;\r\n  --color-text-muted: #2B2F36;\r\n  --color-text-heading: #11142D;\r\n  --color-text-near-black: #13191E;\r\n  --color-text-sidebar-icon: #414247;\r\n  --color-text-dark-grey: #474747;\r\n  --color-text-navy: #293241;\r\n  --color-text-dark2: #1D2939;\r\n  --color-text-near-black2: #1F1F1F;\r\n  --color-text-grey-purple: #808191;\r\n  --color-text-medium-grey: #555555;\r\n  --color-text-grey2: #666666;\r\n  --color-text-grey3: #888888;\r\n  --color-text-light-grey: #999999;\r\n  --color-text-dark3: #333333;\r\n\r\n  /* === SEMANTIC: SUCCESS === */\r\n  --color-success: #57CA22;\r\n  --color-success-alt: #18B74A;\r\n  --color-success-bright: #00C48C;\r\n  --color-success-medium: #33DBBA;\r\n  --color-success-dark: #1A927B;\r\n  --color-success-darker: #167E6A;\r\n  --color-success-darkest: #0E5245;\r\n  --color-success-very-dark: #072721;\r\n  --color-success-green: #166534;\r\n  --color-success-bg: #D0F7EF;\r\n  --color-success-bg-lightest: #D1F5EE;\r\n  --color-success-bg-ultra: rgba(235, 255, 250, 1);\r\n  --color-success-border: #87DCB8;\r\n\r\n  /* === SEMANTIC: WARNING === */\r\n  --color-warning: #FFA319;\r\n  --color-warning-alt: #F4A952;\r\n  --color-warning-dark: #ED9D1D;\r\n  --color-warning-orange: #F79009;\r\n  --color-warning-light: #FDCC77;\r\n  --color-warning-yellow: #F6E314;\r\n  --color-warning-bright: #FFD600;\r\n  --color-warning-yellow-green: #BEDA1E;\r\n\r\n  /* === SEMANTIC: ERROR === */\r\n  --color-error: #FF1943;\r\n  --color-error-alt: #F45252;\r\n  --color-error-red: #F04438;\r\n  --color-error-bright: #F94144;\r\n  --color-error-light: #F98A8A;\r\n  --color-error-dark: #D92D20;\r\n  --color-error-orange: #E64420;\r\n  --color-error-darker: #D32F2F;\r\n  --color-error-darkest: #B42318;\r\n  --color-error-bg: #FEE4E2;\r\n\r\n  /* === SEMANTIC: INFO === */\r\n  --color-info: #33C2FF;\r\n  --color-info-blue: #0288D1;\r\n\r\n  /* === BACKGROUNDS === */\r\n  --color-bg-page: #F7F7F7;\r\n  --color-bg-card: #FFFFFF;\r\n  --color-bg-cream: #FEFCFB;\r\n  --color-bg-light-purple: #F6F3FF;\r\n  --color-bg-purple-tint: #F7F4FC;\r\n  --color-bg-subtle: #F9FAFB;\r\n  --color-bg-muted: #F2F4F7;\r\n  --color-bg-muted-alt: #EFF0F6;\r\n  --color-bg-purple-light: #F4F0FF;\r\n  --color-bg-purple-light2: #E7DFFF;\r\n  --color-bg-grey: #F5F5F5;\r\n  --color-bg-grey2: #F3F3F3;\r\n  --color-bg-grey3: #F1F1F1;\r\n  --color-bg-very-light: #F8F8FA;\r\n  --color-bg-purple-subtle: #F5F7FF;\r\n  --color-bg-mid-grey: #EEEEEE;\r\n  --color-bg-border-grey: #E5E7EB;\r\n\r\n  /* === BORDERS === */\r\n  --color-border: #D0D5DD;\r\n  --color-border-light: #E4E4E4;\r\n  --color-border-medium: #EAECF0;\r\n  --color-border-card: #E4E7EC;\r\n  --color-border-muted: #CFCFD9;\r\n  --color-border-grey: #E0E0E0;\r\n  --color-border-light2: #CCCCCC;\r\n\r\n  /* === NEUTRAL === */\r\n  --color-white: #FFFFFF;\r\n  --color-black: #000000;\r\n  --color-near-black-grey: #202124;\r\n\r\n  /* === PURPLE PALETTE === */\r\n  --color-purple-strong: #3B11B8;\r\n  --color-purple-deep: #0D0131;\r\n  --color-purple-mid: #392B65;\r\n  --color-purple-dark: #15024E;\r\n  --color-purple-deep-alt: #23008A;\r\n\r\n  /* === FEATURE-SPECIFIC COLORS === */\r\n  --color-success-alt2: #12B76A;\r\n  --color-success-green2: #0CAF60;\r\n  --color-success-deep: #027A48;\r\n  --color-success-medium2: #059669;\r\n  --color-teal: #20B2AA;\r\n  --color-highlight: #0B6BCB;\r\n  --color-purple-alt: #5134A9;\r\n  --color-purple-ultra-dark: #0D012E;\r\n  --color-near-white: #FCFCFD;\r\n  --color-bg-off-white: #F9F9F9;\r\n  --color-bg-light-neutral: #EAEAEA;\r\n  --color-bg-success-light: #E3FFE0;\r\n  --color-border-neutral: #D1D5DB;\r\n  --color-text-grey4: #9E9E9E;\r\n  --color-text-grey5: #6B7280;\r\n  --color-warning-pale: #FEF0C7;\r\n  --color-error-pale: #FEF3F2;\r\n  --color-warning-peach: #FFEAD5;\r\n  --color-warning-orange2: #FD853A;\r\n  --color-warning-orange3: #FB6514;\r\n  --color-warning-amber: #F59E0B;\r\n  --color-error-near: #F45251;\r\n  --color-bg-fog: #F2F5F9;\r\n  --color-bg-mint: #F0FDF4;\r\n  --color-bg-lavender: #EEF0F8;\r\n  --color-bg-slate: #E6E8F0;\r\n  --color-error-muted: #DF4B4B;\r\n  --color-border-faint: #DCDCDC;\r\n  --color-border-faint2: #D2D2D2;\r\n  --color-error-burnt: #D33F25;\r\n  --color-success-pastel: #A6E3B8;\r\n  --color-warning-brown: #92400E;\r\n  --color-text-grey6: #808080;\r\n  --color-text-grey7: #767676;\r\n  --color-purple-vivid: #663FDA;\r\n  --color-purple-vivid2: #6544C8;\r\n  --color-teal-bright: #47E9C9;\r\n  --color-google-blue: #4285F4;\r\n  --color-purple-rich: #3510A3;\r\n  --color-shadow-xs: rgba(52, 53, 83, 0.12);\r\n  --color-secondary-darker: #1FB496;\r\n  --color-google-link: #1A0DAB;\r\n  --color-success-deep2: #198639;\r\n  --color-primary-ultra: #0F0238;\r\n\r\n  /* === ANIMATION COLORS === */\r\n  --color-pulse-orange: #ff7f0e;\r\n  --color-pulse-blue: #cfebff;\r\n\r\n  /* === MISC UI COLORS === */\r\n  --color-text-dark-slate: #47525D;\r\n  --color-overlay-grey: rgba(128, 128, 128, 0.78);\r\n  --color-info-shorthand: #1199FF;\r\n  --color-bg-silver: #E9E9E9;\r\n  --color-success-material: #4CAF50;\r\n  --color-accent-violet: #CD7FE8;\r\n  --color-text-charcoal: #404040;\r\n\r\n  /* === SHADOWS === */\r\n  --color-shadow-card: rgba(52, 52, 83, 0.14);\r\n  --color-shadow-sm: rgba(16, 24, 40, 0.05);\r\n\r\n\r\n  /* === FONTS === */\r\n  --font-size-12: 12px;\r\n  --font-size-14: 14px;\r\n  --font-size-15: 15px;\r\n  --font-size-16: 16px;\r\n  --font-size-18: 18px;\r\n  --font-size-20: 20px;\r\n  --font-size-24: 24px;\r\n  --font-size-28: 28px;\r\n  --font-size-30: 30px;\r\n  --font-size-32: 32px;\r\n  --font-size-36: 36px;\r\n\r\n  --line-height-14: 14px;\r\n  --line-height-16: 16px;\r\n  --line-height-18: 18px;\r\n  --line-height-20: 20px;\r\n  --line-height-22: 22px;\r\n  --line-height-24: 24px;\r\n  --line-height-28: 28px;\r\n  --line-height-30: 30px;\r\n  --line-height-32: 32px;\r\n  --line-height-36: 36px;\r\n  --line-height-38: 38px;\r\n  --line-height-44: 44px;\r\n\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  font-family: 'Inter', sans-serif !important;\r\n  background-color: var(--color-bg-page);\r\n  overflow-x: hidden;\r\n}\r\n\r\n#root {\r\n  height: 100%;\r\n}\r\n\r\n.url-log {\r\n  width: 35px;\r\n  height: 35px;\r\n  object-fit: scale-down;\r\n}\r\n\r\n.site-box .box-title {\r\n  overflow: hidden;\r\n  display: inline-block;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  /* font-family: 'RalewayThin'; */\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--color-text-grey-purple);\r\n}\r\n\r\n.header-log-box {\r\n  position: fixed;\r\n  background: var(--color-bg-card);\r\n  height: 63px;\r\n  border-bottom: 2px solid rgba(244, 244, 244, 1);\r\n  width: 250px;\r\n  margin-top: -10px;\r\n  z-index: 10000;\r\n  padding: 15px 20px 15px 25px;\r\n  display: flex;\r\n  align-items: end;\r\n}\r\n\r\n.table-box-title {\r\n  color: var(--color-text-heading);\r\n  overflow: hidden;\r\n  display: inline-block;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-family: 'Inter', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  margin-left: 15px;\r\n  max-width: 30rem;\r\n}\r\n\r\ntd {\r\n  vertical-align: middle !important;\r\n  padding: 5px 5px 5px 15px !important;\r\n}\r\n\r\ntd .MuiCircularProgress-root {\r\n  margin-top: 5px;\r\n}\r\n\r\ntable#pdfExport,\r\nth,\r\ntd {\r\n  border-bottom: 1px solid lightgray;\r\n  border-collapse: collapse;\r\n}\r\n\r\ntable#pdfExport th,\r\ntd {\r\n  padding: 5px;\r\n  text-align: left;\r\n}\r\n\r\n#pdfExport td {\r\n  vertical-align: middle !important;\r\n  padding: 15px 5px 15px 5px !important;\r\n}\r\n\r\n#pdfExport td .MuiCircularProgress-root {\r\n  margin-top: 5px;\r\n}\r\n\r\n.login-image-bg {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.register-img-top {\r\n  top: -11px;\r\n  left: -3px;\r\n  width: 195px;\r\n  transform: rotate(-179.78deg);\r\n  transform: rotate(-360.78deg);\r\n}\r\n\r\n.signup-form .MuiButton-outlinedPrimary {\r\n  font-size: 14px !important;\r\n  font-weight: 700 !important;\r\n  font-style: normal !important;\r\n  letter-spacing: 0.3px !important;\r\n  border-radius: 4px !important;\r\n  border: 3px solid var(--color-primary) !important;\r\n  text-transform: unset !important;\r\n  color: var(--color-primary) !important;\r\n  height: 49px;\r\n}\r\n\r\n.signup-form .MuiButton-outlinedPrimary:hover {\r\n  font-size: 14px !important;\r\n  font-weight: 700 !important;\r\n  font-style: normal !important;\r\n  letter-spacing: 0.3px !important;\r\n  border-radius: 4px !important;\r\n  border: 3px solid var(--color-primary) !important;\r\n  text-transform: unset !important;\r\n  background: var(--color-primary) !important;\r\n  color: var(--color-white) !important;\r\n  height: 49px;\r\n}\r\n\r\n.result-section .MuiCardActions-root .MuiPaper-root {\r\n  background: var(--color-bg-card);\r\n}\r\n\r\n.font-manrope {\r\n  font-family: 'Manrope';\r\n}\r\n\r\n.font-raleway {\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.font-poppins {\r\n  font-family: 'Poppins';\r\n}\r\n\r\n.font-inter {\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.get-more-scan {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-style: normal !important;\r\n  font-weight: 500 !important;\r\n  font-size: 12px !important;\r\n  line-height: 12px !important;\r\n  text-align: right !important;\r\n  letter-spacing: 0.2px !important;\r\n  text-decoration-line: underline !important;\r\n  color: var(--color-purple-strong) !important;\r\n}\r\n\r\n.date-format-css {\r\n  /* font-family: 'Inter'; */\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 16px;\r\n  color: var(--color-text-heading);\r\n  flex: none;\r\n  order: 0;\r\n  align-self: stretch;\r\n  flex-grow: 0;\r\n}\r\n\r\n.form-title {\r\n  font-weight: 400 !important;\r\n  font-size: '18px' !important;\r\n  /* font-family: 'Poppins' !important; */\r\n  color: var(--color-text-heading) !important;\r\n  margin-bottom: '16px' !important;\r\n}\r\n\r\nbutton.MuiButton-containedError {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.scan-modal .common-text,\r\n.common-text {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 17px;\r\n  letter-spacing: 0px;\r\n  /* font-family: 'Inter'; */\r\n  color: rgb(0, 0, 0);\r\n}\r\n\r\n.watch_tutorial {\r\n  color: #8c6af2;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.scroll-block {\r\n  padding: 5px;\r\n  overflow: auto;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-block::-webkit-scrollbar-thumb {\r\n  background-color: rgb(160, 170, 180);\r\n  border: 3px solid rgb(160, 170, 180);\r\n  border-radius: 20px;\r\n}\r\n\r\n.scroll-block::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n.hire-us {\r\n  /* text-align: -webkit-center;\r\n  display: flex;\r\n  padding-top: 15px;\r\n  padding-bottom: 5px;\r\n  padding-left: 19px */\r\n}\r\n\r\n.MuiInputBase-input {\r\n  background: transparent !important;\r\n}\r\n\r\n.scan-button .view-scan-button:hover {\r\n  background-color: transparent;\r\n  border: 0px;\r\n}\r\n\r\n.k-pdf-viewer> :nth-child(3) {\r\n  background-image: unset !important;\r\n  position: unset !important;\r\n}\r\n\r\n.new-added-buy-slot input {\r\n  padding: 5px 5px 5px 10px;\r\n}\r\n\r\n.new-added-buy-slot .top-bottom {\r\n  height: auto;\r\n}\r\n\r\n.new-added-buy-slot button {\r\n  padding: 5px 5px 5px 5px;\r\n}\r\n\r\n.active-toggle .text-label {\r\n  -webkit-transition: all 0.3s 0.1s ease-in-out;\r\n  -moz-transition: all 0.3s 0.1s ease-in-out;\r\n  -o-transition: all 0.3s 0.1s ease-in-out;\r\n  transition: all 0.3s 0.1s ease-in-out;\r\n}\r\n\r\n.watch_tutorial_link {\r\n  font-weight: 700;\r\n  letter-spacing: 0.2px;\r\n  margin: 0px;\r\n  font-size: 13px;\r\n  /* font-family: Poppins; */\r\n  color: var(--color-primary);\r\n}\r\n\r\n/* styles.css */\r\n@keyframes pulseBorder {\r\n  0% {\r\n    border-color: var(--color-pulse-orange);\r\n    box-shadow: 0 0 20px rgba(255, 127, 14, 0.7);\r\n  }\r\n\r\n  50% {\r\n    border-color: var(--color-pulse-blue);\r\n    box-shadow: 0 0 20px rgba(0, 0, 255, 0.7);\r\n  }\r\n\r\n  100% {\r\n    border-color: var(--color-pulse-orange);\r\n    box-shadow: 0 0 20px rgba(255, 127, 14, 0.7);\r\n  }\r\n}\r\n\r\n.chrome-extension-card {\r\n  position: relative;\r\n  background-color: var(--color-pulse-blue);\r\n  border: 2px solid;\r\n  border-color: var(--color-pulse-orange);\r\n  animation: pulseBorder 2s infinite;\r\n  border-radius: 10px;\r\n}\r\n\r\n.chrome-extension-card::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: -15px;\r\n  left: -15px;\r\n  right: -15px;\r\n  bottom: -15px;\r\n  background-color: rgba(255, 127, 14, 0.7);\r\n  opacity: 0.5;\r\n  z-index: -1;\r\n  border-radius: 15px;\r\n}\r\n\r\niframe.seo-space-iframe #root {\r\n  overflow: hidden;\r\n}\r\n.chrome-modal-secondory-text {\r\n  font-family: Inter;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n/* Custom Sleek Thin Scrollbar */\r\n.scrollbar-thin::-webkit-scrollbar {\r\n  height: 6px;\r\n  width: 6px;\r\n}\r\n\r\n.scrollbar-thin::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.scrollbar-thin::-webkit-scrollbar-thumb {\r\n  background: var(--color-border, #D0D5DD);\r\n  border-radius: 4px;\r\n}\r\n\r\n.scrollbar-thin {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--color-border, #D0D5DD) transparent;\r\n}\r\n\r\n/* Animated Gradient Border using CSS @property (Cruip pattern) */\r\n@property --border-angle {\r\n  inherits: false;\r\n  initial-value: 0deg;\r\n  syntax: '<angle>';\r\n}\r\n\r\n@keyframes orbit-border-rotate {\r\n  to {\r\n    --border-angle: 360deg;\r\n  }\r\n}\r\n\r\n.orbit-animated-gradient-border {\r\n  border: 1.5px solid transparent;\r\n  border-radius: 10px;\r\n  background:\r\n    linear-gradient(#ffffff, #ffffff) padding-box,\r\n    conic-gradient(\r\n      from var(--border-angle),\r\n      var(--color-border-light, #E0E0E6) 80%,\r\n      #1FB89C 86%,\r\n      var(--color-primary-bright, #5569ff) 90%,\r\n      #DD588D 94%,\r\n      var(--color-border-light, #E0E0E6)\r\n    ) border-box;\r\n  animation: orbit-border-rotate 4s linear infinite;\r\n}\r\n\r\n/* Backward-compatibility alias */\r\n.orbit-rotating-card-wrapper {\r\n  border: 1.5px solid transparent;\r\n  border-radius: 10px;\r\n  background:\r\n    linear-gradient(#ffffff, #ffffff) padding-box,\r\n    conic-gradient(\r\n      from var(--border-angle),\r\n      var(--color-border-light, #E0E0E6) 80%,\r\n      #1FB89C 86%,\r\n      var(--color-primary-bright, #5569ff) 90%,\r\n      #DD588D 94%,\r\n      var(--color-border-light, #E0E0E6)\r\n    ) border-box;\r\n  animation: orbit-border-rotate 4s linear infinite;\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
